import { render, staticRenderFns } from "./BookingnoTab.vue?vue&type=template&id=77215064&scoped=true"
import script from "./BookingnoTab.vue?vue&type=script&lang=js"
export * from "./BookingnoTab.vue?vue&type=script&lang=js"
import style0 from "./BookingnoTab.vue?vue&type=style&index=0&id=77215064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77215064",
  null
  
)

export default component.exports